import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css, keyframes } from 'styled-components';
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
import { Badge as PrestyledBadge } from '../Ui';
/**
 * Which composite the viewer watches: HD (the content partition) or SD
 * (the low-quality partition), with "Auto" when the relay-capacity
 * controller decides. Hidden when the host publishes no low-quality
 * composite (old hosts, mobile hosts, call mode).
 */
export function QualityBadge({ className }) {
    const quality = StreamrAppService.getOutput().useContentQuality();
    if (!quality?.lowAvailable || quality.active === undefined) {
        return null;
    }
    const label = quality.active === 'high' ? 'HD' : 'SD';
    const text = quality.mode === 'auto' ? `Auto · ${label}` : label;
    const title = quality.mode === 'auto'
        ? 'Quality follows your connection (change in the options menu)'
        : `Quality pinned to ${label}`;
    return (_jsx(QualityBadgeRoot, { className: className, "$switching": quality.switching !== undefined, title: title, children: text }));
}
const pulse = keyframes `
    0%, 100% { opacity: 1; }
    50% { opacity: 0.45; }
`;
const QualityBadgeRoot = styled(PrestyledBadge) `
    align-items: center;
    backdrop-filter: blur(10px);
    background: rgba(0, 0, 0, 0.08);
    color: var(--tv-ui-color-3);
    display: flex;
    font-size: 0.875rem;
    height: 1.75rem;
    padding: 0 0.5rem;
    font-weight: 500;
    white-space: nowrap;
    user-select: none;
    ${({ $switching }) => $switching &&
    css `
            animation: ${pulse} 1s ease-in-out infinite;
        `}
`;
